<script setup lang="ts">
import i18n from '@/lang/i18n';
import vLoaderAnimation from '@/components/template/v-loader-animation.vue';

const props = defineProps<{
  loading: boolean
}>()
</script>
<template>
  <div
    v-show="props.loading"
    class="loading"
    style="position: absolute; top: 15%; height: 90%;"
  >
    <div
      class="d-flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8"
      style="height: 80%; background-color: rgba(150, 150, 150, 0.7);"
    >
      <div class="max-w-md w-full space-y-8">
        <v-loader-animation
          :text="'text-white'"
          :loading-text-style="'text-black text-lg'"
          :loading-text="i18n.global.t('common.loadingText')"
          :addCharacterImg="false"
        />
      </div>
    </div>
  </div>
</template>